// Modul zur Erfassung von einfachen Kosten
"use strict";

import CoreModels from "dias/core/models";
import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "dias/kosten_finanzierung/kosten.controller";
import template from "dias/kosten_finanzierung/kosten.template.jade";
import FoerderantragModels from "dias/foerderantrag/models";
import BetragsrechnerRegistry from "dias/kosten_finanzierung/betragsrechner/services";

import builder from "dias/standard_foerdermodule/utils/builder";


const standard_kosten = angular.module("dias.standard_kosten.standard_kosten", [
  CoreModels.name,
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
  BetragsrechnerRegistry.name,
]);

standard_kosten.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("standard_kosten", "modul-standard-kosten");
})

  .directive("modulStandardKosten", builder.directive(template, controller));

export default standard_kosten;
